import { Button as FBButton } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ButtonSidebar = (props) => {
    const {className, children, ...buttonProps} = props;
    const buttonClass = `rounded-[0px] xl:h-9 xl:w-9 h-8 w-8 ${className || ''}`;
    return (
        <FBButton theme={tenkenTheme.button} color="sidebar" className={buttonClass} {...buttonProps}>
            {children}
        </FBButton>
    );
};

export default ButtonSidebar;